import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../newSrc/pages/Landing/components";
import QuickAccess from "../newSrc/components/QuickAccess/QuickAccess";
import LandingPageContextProvider from "../newSrc/context/LandingPageContextProvider";

export const Layout = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const offlineError: any = {
    backgroundColor: `#ffcccc`,
    color: `#ff0000`,
    width: "100%",
    height: "fitContent",
    margin: "auto",
    textAlign: `center`,
    zIndex: `inherit`,
  };

  const displayNone = {
    display: "none",
  };

  return (
    <>
      <div style={isOnline ? displayNone : offlineError}>
        Please check your internet connection and try again.
      </div>
      <LandingPageContextProvider>
        <Header />
        <Outlet />
        <QuickAccess />
      </LandingPageContextProvider>
    </>
  );
};
